import { useEffect, useState } from "react";
import { Cake, MessageCircle } from "lucide-react";
import { api, coachHeaders } from "../lib/api";
import { anniversairesSemaine, nomCat } from "../lib/categorie";
import { openWhatsApp } from "./ShareWhatsApp";

const quand = (a) => (a.dans === 0 ? "Aujourd'hui" : a.dans === 1 ? "Demain" : a.date.toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long" }));
const souhait = (a) => `🎂 Joyeux anniversaire ${nomCat(a.j)} qui fête ses ${a.age} ans${a.dans === 0 ? " aujourd'hui" : ` ${quand(a).toLowerCase()}`} ! Toute l'équipe de l'USC Jemappes te souhaite une super journée ⚽`;

export const BirthdayBanner = ({ code }) => {
  const [joueurs, setJoueurs] = useState([]);
  useEffect(() => {
    api.get("/joueurs", coachHeaders(code)).then((r) => setJoueurs(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  }, [code]);
  const list = anniversairesSemaine(joueurs);
  if (list.length === 0) return null;
  return (
    <section data-testid="birthday-banner" className="mt-6 rounded-2xl border border-lime/60 bg-lime/10 p-4">
      <h2 className="flex items-center gap-2 font-display text-xl uppercase text-lime"><Cake className="h-5 w-5" />Anniversaires de la semaine</h2>
      <ul className="mt-2 divide-y divide-lime/20">
        {list.map((a) => (
          <li key={a.j.id} data-testid={`birthday-row-${a.j.id}`} className="flex flex-wrap items-center justify-between gap-2 py-2">
            <p className="min-w-0 text-chalk">
              <span className="font-semibold">{nomCat(a.j)}</span>
              <span className={`ml-2 font-mono text-xs uppercase ${a.dans === 0 ? "rounded-full bg-lime px-2 py-0.5 text-ink" : "text-dim"}`}>{quand(a)}</span>
              <span className="ml-2 text-sm text-dim">· {a.age} ans</span>
            </p>
            <button type="button" data-testid={`birthday-wish-${a.j.id}`} onClick={() => openWhatsApp(souhait(a))}
              className="inline-flex items-center gap-1 rounded-full bg-[#25D366] px-3 py-1.5 text-sm font-semibold text-ink transition-transform duration-200 hover:-translate-y-0.5">
              <MessageCircle className="h-4 w-4" />Souhaiter
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
};
